import React, { useEffect, useRef, useState } from 'react'
import Select from 'react-select'
import { joinClientRoles, splitClientRoles } from '../../../features/clientUsers/clientAccess'

// Keeps the menu above the page's dialogs and out of the table's scroll clipping.
export const roleMenuStyles = { menuPortal: (base) => ({ ...base, zIndex: 10000 }) }

const toOption = (role, roles) => {
    const match = roles.find((item) => item.value === role)
    return { value: role, label: match ? match.label : role }
}

const RolePicker = ({ user, roles, onSave, onEmpty }) => {
    const [selected, setSelected] = useState(() => splitClientRoles(user.role))
    // What is stored, or being stored: closing the menu after a chip was removed must not save twice.
    const committed = useRef(joinClientRoles(selected))

    const reset = () => {
        const stored = splitClientRoles(user.role)
        committed.current = joinClientRoles(stored)
        setSelected(stored)
    }

    useEffect(reset, [user.role]) // eslint-disable-line react-hooks/exhaustive-deps

    const commit = (values) => {
        const role = joinClientRoles(values)
        if (role === committed.current) {
            return
        }
        if (!role) {
            onEmpty()
            reset()
            return
        }
        committed.current = role
        onSave(role).then((saved) => {
            if (!saved) {
                reset()
            }
        })
    }

    // Picking from the open menu saves when it closes, so several roles are one request, not one per
    // click. Removing a chip happens with the menu closed, so it saves straight away.
    const handleChange = (options, { action }) => {
        const values = options.map((option) => option.value)
        setSelected(values)
        if (action !== 'select-option' && action !== 'deselect-option') {
            commit(values)
        }
    }

    return (
        <Select
            isMulti
            isClearable={false}
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            placeholder="Not assigned"
            aria-label={`Roles for ${user.userName}`}
            options={roles.map((role) => ({ value: role.value, label: role.label }))}
            value={selected.map((role) => toOption(role, roles))}
            onChange={handleChange}
            onMenuClose={() => commit(selected)}
            menuPortalTarget={document.body}
            styles={roleMenuStyles}
        />
    )
}

export default RolePicker
